import { Directive, effect, ElementRef, inject, input, OnInit } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { PlatformService, WINDOW } from '@seven1/angular/ssr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface CustomScrollEvent extends Event {
    target: Document;
}

@Directive({
    selector: '[appNavScroll]',
    standalone: true,
})
export class NavScrollDirective implements OnInit {
    lightMode = input<boolean>(false);
    private _window = inject(WINDOW);
    private scrollEl = inject(ElementRef);
    private platformService = inject(PlatformService);
    private scrollObservable?: Observable<Event>;
    private element: HTMLElement = this.scrollEl.nativeElement;

    constructor() {
        if (this.platformService.isBrowser) {
            // @ts-expect-error window has events if present
            this.scrollObservable = fromEvent(this._window, 'scroll').pipe(takeUntilDestroyed());
        }
        effect(() => {
            const lightMode = this.lightMode();
            if (lightMode) {
                this.replaceClasses({
                    classToRemove: 'dark-mode',
                    classToAdd: 'light-mode',
                });
            } else {
                this.replaceClasses({
                    classToRemove: 'light-mode',
                    classToAdd: 'dark-mode',
                });
            }
        });
    }

    ngOnInit(): void {
        this.scrollObservable?.subscribe((event: Event) => {
            this.checkScrollPosition(event as CustomScrollEvent);
        });
    }

    private checkScrollPosition(event: CustomScrollEvent): void {
        try {
            const scrollPosition = this._window?.scrollY || 0;
            const bodyHeight = event.target?.body?.scrollHeight;
            const scrollThresholdPx = bodyHeight ? 500 : 0;
            if (scrollPosition < scrollThresholdPx) {
                this.replaceClasses({
                    classToRemove: 'logo-white',
                    classToAdd: 'logo-dark',
                });
            } else {
                this.replaceClasses({
                    classToRemove: 'logo-dark',
                    classToAdd: 'logo-white',
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    replaceClasses({ classToRemove, classToAdd }: { classToRemove: string; classToAdd: string }): void {
        this.element.classList.remove(classToRemove);
        this.element.classList.add(classToAdd);
    }
}
